// extracted by mini-css-extract-plugin
export default {"accordion":"CollapseMeta_accordion__c44tb","hasChildren":"CollapseMeta_hasChildren__-8dQ9","header":"CollapseMeta_header__3eKIS"};